import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/apply/img-file-delete.svg'
import _imports_1 from '@/assets/img/apply/icon-checked.svg'
import _imports_2 from '../../assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b4bf9a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "応募辞退", -1))
const _hoisted_4 = { class: "p-apply" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-apply_headingLv1 u-mn-hidden" }, "応募辞退", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-apply_text" }, "今後求人をお探しする際の参考にいたしますので、ご希望に合わない点などございましたらご入力ください。", -1))
const _hoisted_7 = { class: "p-apply-card" }
const _hoisted_8 = { class: "p-apply-card_heading" }
const _hoisted_9 = { class: "p-apply_label-select" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "辞退理由（任意）", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "p-apply_textarea" }
const _hoisted_13 = { class: "p-apply_button-wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-apply_button" }, "応募しない", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  class: "c-modal js-modal-container",
  id: "apply"
}
const _hoisted_17 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_18 = { class: "c-modal_content" }
const _hoisted_19 = { class: "js-apply-tab" }
const _hoisted_20 = { class: "p-apply-modal" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_22 = {
  key: 0,
  class: "p-apply-modal_heading"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "js-apply-tab" }
const _hoisted_28 = { class: "p-apply-modal" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "p-apply-modal_heading" }, [
    /*#__PURE__*/_createTextVNode(" 1件の応募辞退を "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 受け付けました ")
  ])
], -1))
const _hoisted_30 = { class: "p-apply-modal_text" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg" }, null, -1))
const _hoisted_32 = { class: "l-wrapper_nav" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getShintyokuNoSrc2Service, submitUpdateRefusalShintyokuService } from '@/api/services/shintyokuService';
import { getOrderInfoById } from '@/api/shintyokuEndpoint';
import { OrderInfo, OrderRefusal, UpdateResponse } from '@/types';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import Loading from '@/components/Loading.vue';
import { MstMyPageItem } from '@/types/mstMyPage';
import store from '@/store';
import { domHelperUtils } from '@/utils/domHelper';
import { mypageUtils } from '@/utils/mypage';


export default /*#__PURE__*/_defineComponent({
  __name: 'RefusalFormView',
  setup(__props) {

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
// Submit Data
const orderInfo = ref<OrderInfo>();

// Modal Events
const showModal = ref(false);
const isConfirmed = ref(false);
const btnClose = ref(true);
const errorMessage = ref('');
const submitSuccess = ref(false);
const isLoading = ref<boolean>(false);
// Form Data
const failureIdValue = ref<number>(0);
const refusalReasonValue = ref<string>(''); // 初期値は空文字列
const mstFailureList = ref<MstMyPageItem[]>([]);
const companyNameAndJobTitle = ref('');
// Route => Get Params
const route = useRoute();
const router = useRouter();

const orderId = route.params.orderId as string;

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const handleBack = () => {
  let previousRoute = store.getters['router/previousRoute'];
  mypageUtils.handleBack(router, previousRoute);
};

// Events
const handleShow = (isShow: boolean) => {
  showModal.value = isShow;
  btnClose.value = !isShow;
};

const handleLeaveForm = () => {
  if (submitSuccess.value) {
    router.push('/refusallist/');
    return;
  }
  resetValueRef();
};

const resetValueRef = () => {
  showModal.value = false;
  isConfirmed.value = false;
  btnClose.value = true;
  errorMessage.value = '';
  submitSuccess.value = false;
  document.body.style.overflow = '';
  isLoading.value = false;
};

const handleClickOutSideModal = (event: Event) => {
  const target = event.target as Element | null;
  // Check if the click was inside the model-confirm-form div
  if (target && !target.closest('.c-modal_inner') && submitSuccess.value) {
    router.push('/refusallist/');
    return;
  }
};

/**
 * Submit Refusal Form
 */
const handleSubmit = async () => {
  if (isConfirmed.value) {
    resetValueRef();
    return;
  }
  handleShow(false);
  isLoading.value = true;
  // Create a new OrderRefusal object
  const orderRefusal: OrderRefusal[] = [
    {
      orderId: Number(orderId),
      failureId: failureIdValue.value, // INPUT
      refusalReason: refusalReasonValue.value, // INPUT
    },
  ];
  // Request to submitRefusalShintyokuService
  const response = await submitUpdateRefusalShintyokuService(orderRefusal);
  handleShowMessage(response);
  isLoading.value = false;
};

/*
 * Handles the display of messages based on the response from an update operation.
 * @param response - The response object from the update operation, or null if no response is available.
 */
const handleShowMessage = (response: UpdateResponse | null) => {
  // Check if the response is null and handle the null case if needed
  if (!response) {
    // If there's no response, exit the function early
    return;
  }

  // Check for ignored orders and set an error message if any are found
  if ((response.ignoreOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE);
  }

  // Check for unapproved orders and set an error message if any are found
  if ((response.unApprovedOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS);
  }

  // Check for unavailable orders and set an error message if any are found
  if ((response.unAvailableOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION);
  }

  // Check for other exceptions and set an error message if any are found
  if (typeof response.otherException === 'string' && response.otherException.length > 0) {
    errorMessage.value = handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_REGISTER_PROGRESS_HISTORY_MSG);
  }

  // Determine whether to show a confirmation or success message
  if (errorMessage.value.length > 0) {
    // If there is an error message, set the confirmation flag
    isConfirmed.value = true;
  } else {
    // If there are no error messages, set both confirmation and success flags
    isConfirmed.value = true;
    submitSuccess.value = true;
    document.body.style.overflow = '';
  }
  handleShow(true);
};

/**
 * Generates a formatted message for invalid orders.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessageForInvalidOrders = (msg: string): string => {
  return `${msg}<br/>${orderId} : ${companyNameAndJobTitle.value}`;
};

/**
 * Generates a formatted message.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessage = (msg: string): string => {
  return msg;
};

// Hook
onMounted(async () => {
  // Get Mst Failure
  const orderIdParam = Number(orderId);
  if (isNaN(orderIdParam)) {
    router.replace({ path: 'mynavi/404' });
    return;
  }

  mstFailureList.value = await store.dispatch(storeBase.MST_FAILURE);

  const orderInfoResponse = await getOrderInfoById(orderIdParam);
  if (orderInfoResponse != null && orderInfoResponse.responseFault.responseId === 'N003') {
    router.replace({ path: 'mynavi/404' });
  } else {
    if (orderInfoResponse.detail != null) {
      orderInfo.value = orderInfoResponse.detail;
      companyNameAndJobTitle.value = orderInfo.value.clientName + '／' + orderInfo.value.positionname;
    }
    const requestParams: TrnShintyokuSelectRequest = {
      orderId: Number(orderInfo.value?.orderId),
    };

    const shintyoku = await getShintyokuNoSrc2Service(requestParams);

    if (shintyoku.totalCount == 0) {
      router.replace({ path: 'mynavi/404' });
    }
  }

  document.addEventListener('click', handleClickOutSideModal);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutSideModal);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", { class: "c-head-mn u-lg-hidden" }, [
        _createElementVNode("button", {
          onClick: handleBack,
          "aria-label": "戻る"
        }),
        _hoisted_3
      ]),
      _createElementVNode("main", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(companyNameAndJobTitle.value), 1)
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((failureIdValue).value = $event))
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mstFailureList.value, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.text), 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, failureIdValue.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refusalReasonValue).value = $event)),
              placeholder: "メッセージを追加（任意）",
              maxlength: "200"
            }, null, 512), [
              [_vModelText, refusalReasonValue.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "u-modal-open-button js-modal-open-button",
              "data-modal-target": "apply",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleShow(true)))
            }, _hoisted_15),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "c-modal_close",
                  type: "button",
                  "aria-label": "閉じる",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleLeaveForm()))
                }),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, [
                        _hoisted_21,
                        (!isConfirmed.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                              _createTextVNode(" 1件の求人が "),
                              _hoisted_23,
                              _createTextVNode(" 「応募しない求人一覧」に"),
                              _hoisted_24,
                              _createTextVNode("移動します。 "),
                              _hoisted_25,
                              _createTextVNode(" よろしいでしょうか？ ")
                            ]))
                          : (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "p-apply-modal_heading",
                              innerHTML: errorMessage.value
                            }, null, 8, _hoisted_26))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "p-apply-modal_button -apply",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleSubmit())),
                          type: "button"
                        }, "OK"),
                        _withDirectives(_createElementVNode("button", {
                          class: "p-apply-modal_button",
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (resetValueRef()))
                        }, " キャンセル ", 512), [
                          [_vShow, !isConfirmed.value]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, !submitSuccess.value]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("p", _hoisted_30, _toDisplayString(companyNameAndJobTitle.value), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/refusallist/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("応募しない求人一覧へ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/jobsearch/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("求人一覧へ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 512), [
                    [_vShow, submitSuccess.value]
                  ])
                ])
              ]),
              _hoisted_31
            ], 512), [
              [_vShow, showModal.value]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_35, 8, _hoisted_33)
    ])
  ]))
}
}

})